// Mirrors backend ROLE_HOME_ROUTE (healthcare_entities/constants.py).
// Roles not present here fall back to the default home URL passed to
// resolveRoleHome. Kept as a simple map so it can later be replaced by an
// API-driven lookup without changing call sites.
export const ROLE_HOME_ROUTES: Record<string, string> = {
  SCHED: '/app/organization/assignments',
};

export const resolveRoleHome = (role: string | null | undefined, fallback: string): string => {
  if (!role) return fallback;
  return ROLE_HOME_ROUTES[role] ?? fallback;
};
